import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { Module } from "@modules/agreements/types";
import { ModuleFormValues } from "@modules/agreements/validations";

export async function createModuleService(data: ModuleFormValues): Promise<Module> {
  const payload = appendFormData(data);

  const { data: module } = await api.post<Module>("agreement_modules_admin/", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return module;
}
